/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Price_Block2_H3Inputs */

const es_landing_price_block2_h3 = /** @type {(inputs: Landing_Price_Block2_H3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Después, solo cuando tu barco navega.`)
};

const gl_landing_price_block2_h3 = /** @type {(inputs: Landing_Price_Block2_H3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Despois, só cando o teu barco navega.`)
};

const en_landing_price_block2_h3 = /** @type {(inputs: Landing_Price_Block2_H3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After that, only when your boat is out.`)
};

/**
* | output |
* | --- |
* | "After that, only when your boat is out." |
*
* @param {Landing_Price_Block2_H3Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_price_block2_h3 = /** @type {((inputs?: Landing_Price_Block2_H3Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Price_Block2_H3Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_price_block2_h3(inputs)
	if (locale === "en") return en_landing_price_block2_h3(inputs)
	return es_landing_price_block2_h3(inputs)
});